(() => {
  let initialized = false;

  function initializePreorderVariantSync() {
    if (initialized) return;

    // Aspetta che il sistema eventi del tema Refresh sia disponibile.
    if (
      typeof subscribe !== 'function' ||
      typeof PUB_SUB_EVENTS === 'undefined' ||
      !PUB_SUB_EVENTS.variantChange
    ) {
      setTimeout(initializePreorderVariantSync, 100);
      return;
    }

    initialized = true;

    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      if (!data) return;

      const { sectionId, html } = data;

      if (!sectionId || !html) return;

      /*
       * Trova il form prodotto attualmente visibile
       * e quello appena generato da Shopify per la nuova variante.
       */
      const currentForm = document.getElementById(
        `product-form-${sectionId}`
      );

      const updatedForm = html.getElementById(
        `product-form-${sectionId}`
      );

      if (!currentForm || !updatedForm) return;

      const currentProductForm = currentForm.closest('product-form');
      const updatedProductForm = updatedForm.closest('product-form');

      if (!currentProductForm || !updatedProductForm) return;

      /*
       * Sostituisce l'intero blocco acquisto con quello
       * correttamente generato per la nuova variante.
       *
       * In questo modo vengono aggiornati automaticamente:
       * - testo del pulsante
       * - box preordine
       * - proprietà del carrello
       * - pagamento dinamico
       */
      const replacement = document.importNode(
        updatedProductForm,
        true
      );

      currentProductForm.replaceWith(replacement);

      /*
       * Riattiva eventuali pulsanti di pagamento dinamico.
       */
      if (
        window.Shopify &&
        window.Shopify.PaymentButton &&
        typeof window.Shopify.PaymentButton.init === 'function'
      ) {
        window.Shopify.PaymentButton.init();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializePreorderVariantSync,
      { once: true }
    );
  } else {
    initializePreorderVariantSync();
  }
})();